import React from 'react';
import PropTypes from 'prop-types';

// TODO: sanitize dangerouslySetInnerHTML content with DOMPurify once it is added
// as a project dependency (requires approval per ROR-016).
const TableCell = ({ as: Tag = 'td', className, colSpan, contentClassName = 'lbv2__cell-content', dangerouslySetInnerHTML, children }) => (
  <Tag className={className} colSpan={colSpan}>
    {dangerouslySetInnerHTML
      ? <div className={contentClassName} dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
      : <div className={contentClassName}>{children}</div>
    }
  </Tag>
);

TableCell.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  colSpan: PropTypes.number,
  contentClassName: PropTypes.string,
  dangerouslySetInnerHTML: PropTypes.shape({ __html: PropTypes.string }),
  children: PropTypes.node,
};

export default TableCell;
